import {Component, NgZone, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'mbnm-zoom-dialog',
    templateUrl: './zoom-dialog.component.html',
    styleUrls: ['./zoom-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ZoomDialogComponent implements OnInit {

  public imageUrl;
  public imageLoaded;
  constructor(private zone: NgZone) { }

  ngOnInit(): void {
  }
}
